const Resources = {

    table_headers: [
        { 
            text:   'Scenario',
            align:  'start',
            value:  'scenario',
            type:   'link',
        },
        {
            text:   'FTE Hours',
            value:  'fte_hours' 
        },
        {
            text:   'Benefits',
            value:  'benefits'
        },
        {
            text:   'Non-productive',
            value:  'nonproductive'
        },
        {
            text:   'Management',
            value:  'management_team'
        },
        {
            text:   'Wage',
            value:  'average_wage'
        },
        {
            text:   'Report',
            value:  'Print',
            type: 'link_action'
        }
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Budgeting',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Scenarios',
            href:   'budgeting-staffing-scenario',
            arrow:  "",
        },
    ],

    helps: [
        {
            label: '¿How to create a Staffing Scenario?', 
            instruction: `https://scribehow.com/embed/Create_A_New_Staffing_Scenario__pIKdJDQwRz-IDOA-vuA5bg?as=scrollable`
        },
    ],

}

export default Resources;